import 'bootstrap/dist/css/bootstrap.min.css';
import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import 'react-toastify/dist/ReactToastify.css';
import './assets/css/custom.css';
import "./index.css";

import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import App from "./components/app";
import { persistor, store } from './redux/store';

// Lazy loaded components
const Login = React.lazy(() => import('./screen/Signin'));
const AfterLogin = React.lazy(() => import('./screen/after-login'));
const BoardList = React.lazy(() => import('./screen/boardlist'));
const BoardsPage = React.lazy(() => import('./screen/boards'));
const BoardsV2Page = React.lazy(() => import('./screen/boards-v2'));
const JobSetupPage = React.lazy(() => import('./screen/jobs/index'));
const JobsPage = React.lazy(() => import('./screen/jobs/jobs'));
const SPC = React.lazy(() => import("./screen/spc"));
const SPCGraph = React.lazy(() => import("./screen/spc/spc-graph"));
const ActivityReport = React.lazy(() => import('./screen/activity_report'));
const ArchivedListReport = React.lazy(() => import('./screen/archived_list_report'));
const GanttChartPage = React.lazy(() => import('./screen/gantt-chart/index'));
const ItemGanttChartPage = React.lazy(() => import('./screen/gantt-chart/item'));
const ReportsPage = React.lazy(() => import('./screen/reports/index'));
const JobsReportsPage = React.lazy(() => import('./screen/reports/jobs'));
const TaskDetail = React.lazy(() => import('./screen/task-detail'));
const ChangeBranch = React.lazy(() => import('./screen/Signin/change_branch'));
const ChangePassword = React.lazy(() => import('./screen/Signin/change_password'));
const FormEmailNotificationm = React.lazy(() => import('./components/forms/email_notification'));
const FormsPage = React.lazy(() => import('./screen/forms'));
const QRScaner = React.lazy(() => import('./screen/forms/QRScaner'));
const CreateFormPage = React.lazy(() => import('./screen/forms/create-form'));
const CreateRecordPage = React.lazy(() => import('./screen/forms/create-record'));
const UpdateRecordPage = React.lazy(() => import('./screen/forms/update-record'));
const RecordsPage = React.lazy(() => import('./screen/forms/records'));
const PermissionDenied = React.lazy(() => import('./screen/permission-denied'));

// Root Component
const Root = () => {
	return (
		<div style={{ height: '100%' }}>
			<React.StrictMode>
				<Provider store={store}>
					<PersistGate loading={null} persistor={persistor}>
						<BrowserRouter basename={"/"}>
							<Suspense fallback={<div>Loading...</div>}>
								<Switch>
									<Route exact path={`/`} component={Login} />
									<App>
										<Route path={`/permission-denied`} component={PermissionDenied} />
										<Route path={`/forms/:form_id/create/alert`} component={FormEmailNotificationm} />
										<Route exact path={`/qr-scan`} component={QRScaner} />
										<Route path={`/loading`} component={AfterLogin} />
										<Route path={`/change-branch`} component={ChangeBranch} />
										<Route path={`/change-password`} component={ChangePassword} />
										<Route path={`/graph/spc/:spc_id`} component={SPCGraph} />
										<Route path={`/spc`} component={SPC} />
										<Route exact path={`/forms`} component={FormsPage} />
										<Route exact path={`/forms/:formId/records`} component={RecordsPage} />
										<Route exact path={`/forms/:formId/records/create`} component={CreateRecordPage} />
										<Route exact path={`/forms/:formId/records/:recordId/change`} component={UpdateRecordPage} />
										<Route exact path={`/forms/create`} component={CreateFormPage} />
										<Route exact path={`/forms/:formId/create`} component={CreateFormPage} />
										<Route exact path={`/jobs/:jobSetupId`} component={JobsPage} />
										<Route exact path={`/jobs`} component={JobSetupPage} />
										<Route exact path={`/boards`} component={BoardsPage} />
										<Route exact path={`/boards-v2`} component={BoardsV2Page} />
										<Route exact path={`/board/:board_id`} component={BoardList} />
										<Route exact path={`/reports`} component={ReportsPage} />
										<Route exact path={`/reports/jobs`} component={JobsReportsPage} />
										<Route path={`/timeline`} component={GanttChartPage} />
										<Route path={`/item/timeline`} component={ItemGanttChartPage} />
										<Route path={`/task-detail/:board_id/:list_id/:item_id`} component={TaskDetail} />
										<Route path={`/item/cadence/report`} component={ActivityReport} />
										<Route path={`/archived/list/report`} component={ArchivedListReport} />
									</App>
								</Switch>
							</Suspense>
						</BrowserRouter>
					</PersistGate>
				</Provider>
			</React.StrictMode>
		</div>
	);
};

ReactDOM.render(<Root />, document.getElementById("root"));
